import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '@environment/environment';
import { FeatureAccessService } from '@app/services/feature-access/feature-access.service';
import { FeatureKey } from '@pdqdev/pdq-shared/dist/utils/features-manifest';
import { ExtensionComponentType } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { map, take } from 'rxjs/operators';

/**
 * Blocks a route when its feature is disabled in /feature-access/me.
 * No-op when the env toggle is off.
 * Waits for feature-access data (loaded after shop) before deciding.
 * Fails open on load error. Redirects to /settings to avoid redirect loops.
 */
export function featureAccessGuard(feature: FeatureKey): CanActivateFn {
  return () => {
    if (!environment.FEATURE_ACCESS_GATING_ENABLED) return true;
    const featureAccess = inject(FeatureAccessService);
    const router = inject(Router);
    const check = () => (featureAccess.isEnabled(feature) ? true : router.parseUrl('/settings'));
    if (featureAccess.loaded) return check();
    return featureAccess.whenReady$.pipe(take(1), map(check));
  };
}

export function extensionTypeAccessGuard(type: ExtensionComponentType): CanActivateFn {
  return () => {
    if (!environment.FEATURE_ACCESS_GATING_ENABLED) return true;
    const featureAccess = inject(FeatureAccessService);
    const router = inject(Router);
    const check = () => (featureAccess.isExtensionTypeEnabled(type) ? true : router.parseUrl('/convert/extensions'));
    if (featureAccess.loaded) return check();
    return featureAccess.whenReady$.pipe(take(1), map(check));
  };
}
